import api from "./api";

export interface CreateUserPayload {
  email: string;
  password: string;
  full_name: string;
  role: "student" | "growlearn" | "aca_member";
}

export const UserService = {
  create: (payload: CreateUserPayload) =>
    api.post<{ success: boolean; user_id: string }>("/users", payload),

  list: () =>
    api.get<{
      users: Array<{
        user_id: string;
        email: string;
        full_name: string;
        role: string;
      }>;
    }>("/users"),
};
